import { getDefaultChatRequestBody } from '@/pages/DigitalHuman/util/util';
import axios from 'axios'

export const getASRSync = (data: {
  sessionId: string;
  id: string;
  address: string;
}) => {
  return axios({
    method: "post",
    url: `https://vlog-zhuangyou.shuwen.com/api/algo/asr/v2`,
    data: {
      appId: 'xihu-city-walk',
      ...data,
      id: getDefaultChatRequestBody().id,
    }
  });
};
